var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resources-builder',{attrs:{"value":_vm.value,"avoidTypes":_vm.avoidTypes,"partId":"self-paced"}})
}
var staticRenderFns = []

export { render, staticRenderFns }